import config from "../config.json"; 
import React, { useContext, useEffect, useState } from "react"; 
import ConfirmDialog from './ConfirmDialog'
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";


const DeviceItem = React.memo(({ item, doEdit,doDelete }) => {
    return (
        <div className="row border rounded mb-3 m-1 shadow" key={"ddd" + item.id}>
            <div className="col p-2">
                <div className="row">
                    <div className="col-auto d-flex align-items-center pe-0">
                        <div className=" row">
                            <div className="col">
                                <div className=" row">
                                    <div className="col">
                                        <img src={`${item.icon && item.icon !== '' ? `${config.apiUrl}/piccar/${item.icon}` : '/images/car1.png'}`}
                                            className="imgDeviceMenuLeft" alt="fuel" />
                                    </div>
                                </div>
                                <div className=" row mt-1">
                                    <div className="col">
                                        <span className="text-secondary fs-6">{item.deviceName}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col ">
                        <div className="row">
                            <div className="col">
                                {item.name}
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col fs-7">
                                <span className=" me-1">تاریخ تنظیم:</span>
                                <span className="text-secondary me-2">{item.dateFa}-{item.timeDate}</span>
                                <span className=" me-1">آخرین زمان محاسبه :</span>
                                <span className="text-secondary me-2">{item.dateUpdateFa}-{item.timeDateUpdate}</span>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col fs-7">
                                <span className=" me-1">نوع:</span>
                                <span className="text-secondary me-2">{item.mode}</span>
                                <span className=" me-1">کیلومتر طی شده :</span>
                                <span className="text-secondary me-2">{item.distance}</span>
                                <span className=" me-1">روز سپری شده:</span>
                                <span className="text-secondary me-2">{item.days}</span>
                            </div>
                        </div>

                    </div>
                    <div className="col-auto col d-flex align-items-center">
                        <div className="btn-group">
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={e => { doEdit(e, item.id) }} >
                                <span className="p-2">ویرایش</span>
                            </button>
                            <button
                                className="btn btn-danger btn-sm" 
                                onClick={e=>{doDelete(e,item.id)}} >
                                <span className="p-2">حذف</span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
});


export default function OilChangeList({ doRefresh, doEdit }) {
    //const { devices, changed, doChanged, setDefaultDevice, setRoutePoint, command, setCommand } = useContext(MainContext);
    const [showConfirm, setShowConfirm] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [list, setList] = useState([]);
    const [id,setId]=useState(0)

    useEffect(() => {
        DeviceServiceList()
    }, []);
    useEffect(() => {
        if (doRefresh > 0)
            DeviceServiceList()
    }, [doRefresh]);

    const DeviceServiceList = async () => {
        setIsLoading(true);
        await noronServices.DeviceServiceList({
            from: 0,
            pageSize: 1000,
            where: '',
            order: "",
        })
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                setList(data.payload.list);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }


    const [deleteIng,setDeleteIng]=useState(false)
    const doDelete = async () => {
        setDeleteIng(true);
        await noronServices.DeviceServiceDelete(id)
            .then(({ data }) => {
                setDeleteIng(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                DeviceServiceList()
            })
            .catch(err => {
                setDeleteIng(false);
            });
    }



    return (
        <>
            <ConfirmDialog
             show={showConfirm}
                title="توجه"
                handleDo={doDelete}
                handleCancel={(e) => setShowConfirm(false)}
                isBusy={false}
            >
                <div className='row'>
                    <div className='col'>
                        <div className="alert alert-danger" role="alert">
                             آیا از حذف این اطلاعات اطمینان دارید؟
                        </div>
                    </div>
                </div>
            </ConfirmDialog>

            {isLoading &&
                <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>}

            <div className="container">
                {list.map(item => (
                    <DeviceItem
                        key={item.id}
                        item={item}
                        doEdit={doEdit}
                        doDelete={(e,idd)=>{
                            e.preventDefault();
                            setId(idd);
                            setShowConfirm(true)
                        }}
                    />
                ))}
            </div>


        </>

    );

}
